import TabPanel from "@mui/lab/TabPanel";

import DeviceSettingsGroup from "./device-settings/device-settings-group.component";

interface DeviceSettingsProps {
  readonly expandedStates: Record<string, boolean>;
  readonly onExpandedChange: (
    namePrefix: string
  ) => (event: React.SyntheticEvent, expanded: boolean) => void;
}

export default function DeviceSettings({
  expandedStates,
  onExpandedChange
}: DeviceSettingsProps) {
  const handleExpandedChange =
    (namePrefix: string) =>
    (event: React.SyntheticEvent, expanded: boolean) => {
      onExpandedChange(namePrefix)(event, expanded);
    };
  return (
    <TabPanel value="devices">
      <DeviceSettingsGroup
        label="Hearing Aids"
        namePrefix="hearing_aids"
        expanded={expandedStates.hearing_aids}
        onChange={handleExpandedChange("hearing_aids")}
      />
      <DeviceSettingsGroup
        label="Domes"
        namePrefix="domes"
        disableColor
        disableBattery
        expanded={expandedStates.domes}
        onChange={handleExpandedChange("domes")}
      />
      <DeviceSettingsGroup
        label="Receivers"
        namePrefix="receivers"
        disableBattery
        expanded={expandedStates.receivers}
        onChange={handleExpandedChange("receivers")}
      />
      <DeviceSettingsGroup
        label="Tubes"
        namePrefix="tubes"
        disableColor
        disableBattery
        expanded={expandedStates.tubes}
        onChange={handleExpandedChange("tubes")}
      />
      <DeviceSettingsGroup
        label="Earmolds"
        namePrefix="earmolds"
        disableColor
        disableBattery
        expanded={expandedStates.earmolds}
        onChange={handleExpandedChange("earmolds")}
      />

      <DeviceSettingsGroup
        label="Chargers"
        namePrefix="chargers"
        disableColor
        disableBattery
        disableEar
        expanded={expandedStates.chargers}
        onChange={handleExpandedChange("chargers")}
      />
      <DeviceSettingsGroup
        label="Batteries"
        namePrefix="batteries"
        disableBattery
        disableEar
        expanded={expandedStates.batteries}
        onChange={handleExpandedChange("batteries")}
      />
      <DeviceSettingsGroup
        label="Remotes"
        namePrefix="remotes"
        disableColor
        disableBattery
        disableEar
        expanded={expandedStates.remotes}
        onChange={handleExpandedChange("remotes")}
      />
      <DeviceSettingsGroup
        label="Others"
        namePrefix="others"
        disableColor
        disableBattery
        disableEar
        expanded={expandedStates.others}
        onChange={handleExpandedChange("others")}
      />
    </TabPanel>
  );
}
